module.exports = __webpack_public_path__ + "../front/img/divide3.90c2bda1.svg";